import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../mappers/monthly-topic.mapper";
import * as i2 from "../data.requirements";
export class GetMonthlyTopicUseCase {
    constructor(mapper, data) {
        this.mapper = mapper;
        this.data = data;
    }
    run() {
        return this.data.getMonthlyTopic().pipe(this.mapper.map);
    }
}
GetMonthlyTopicUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GetMonthlyTopicUseCase_Factory() { return new GetMonthlyTopicUseCase(i0.ɵɵinject(i1.MonthlyTopicMapper), i0.ɵɵinject(i2.DataRequirementsInjectionToken)); }, token: GetMonthlyTopicUseCase, providedIn: "root" });
